import dateUtils from '@utils/DateUtils'
import {randomColorRGB, rybColorWheel} from '@utils/Color'
import sizeUtils from '@utils/sizeUtils'

export default class Workspace {
  constructor (obj, index) {
    this._color = rybColorWheel[index + 1] || randomColorRGB()
    this._isWorkspace = true
    this._currentSize = obj.current_size ? obj.current_size : 0
    this._totalItems = obj.total_items ? obj.total_items : 0
    this._name = obj.name
    this._isPrivate = obj.is_private ? obj.is_private : false
    this._owner = obj.owner ? obj.owner : undefined
    this._ownerId = obj.owner_id ? obj.owner_id : undefined
    this._shareWorkspaces = obj.share_workspaces ? obj.share_workspaces : undefined
    this._sizeMb = obj.size_mb ? this.transformSize(obj.size_mb) : obj.size_mb_share ? this.transformSize(obj.size_mb_share) : '0 KB'
    this._id = obj.id ? obj.id : undefined
    this._createdAt = obj.created_at ? dateUtils.convertUTCToLocalDateV2(obj.created_at) : undefined
    this._isOwner = obj.is_owner
    this._userShared = obj.user_shared
    this._tags = obj.categories || []
  }

  transformSize (size) {
    if (size !== undefined && size !== null && size !== '') {
      return sizeUtils.transfSize(size)
    } else {
      return '0 KB'
    }
  }

  get color () {
    return this._color
  }
  get isOwner () {
    return this._isOwner
  }
  get isWorkspace () {
    return this._isWorkspace
  }
  get currentSize () {
    return this._currentSize
  }
  get totalItems () {
    return this._totalItems
  }
  get isPrivate () {
    return this._isPrivate
  }

  get owner () {
    return this._owner
  }
  get ownerId () {
    return this._ownerId
  }
  get shareWorkspaces () {
    return this._shareWorkspaces
  }

  get name () {
    return this._name
  }

  get id () {
    return this._id
  }

  get sizeMb () {
    return this._sizeMb
  }

  get createdAt () {
    return this._createdAt
  }

  get userShared () {
    return this._userShared
  }
  set userShared (newValue) {
    this._userShared = newValue
  }

  get tags () {
    return this._tags
  }

  set tags (val) {
    this._tags = val
  }
}



// WEBPACK FOOTER //
// ./src/models/workspace/workspace.js